import { useFormikContext } from "formik";
import React from "react";
import { labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import TextFieldStyles from "../TextField/TextField.module.css";
import styles from "../SurveyTextarea/SurveyTextarea.module.css";


export default function TextArea({ field_label, displayLabel, parent, isRequired, charactersRange }) {
  const { getFieldProps } = useFormikContext();
  const name = parent ? `${parent}.${field_label}` : field_label;
  const min = charactersRange?.min ? parseInt(charactersRange.min, 10) : 0;
  const max = charactersRange?.max ? parseInt((charactersRange.max), 10) : 0;
  const [charCount, setCharCount] = React.useState(0);
  const isTooSmall = min > 0 && charCount < min;
  const isTooMuch = max > 0 && charCount > max;

  const handleInputChange = (e) => {
    setCharCount(e.target.value.length);
  };

  
  return (
    <div className={TextFieldStyles.inputContainer}>
      <div className="label-container" style={{display: 'flex', justifyContent: 'space-between'}}>
        <label htmlFor="textarea" className={TextFieldStyles.label}>{labelName(displayLabel || field_label)}{isRequired==="true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}</label>
          {/* {(max || min) && (
            <div style={{display: 'flex'}}>
              {min ? (
                <label className={TextFieldStyles.label}>Min:<span>{min}</span></label>
              ): null}
              {max > 0 ? (
                <label className={TextFieldStyles.label}>Max:<span>{max}</span></label>
              ): null}
            </div>
          )}*/}
      </div>
      <textarea
        id={field_label}
        className={TextFieldStyles.input}
        {...getFieldProps(name)}
        onChange={(e) => {
          getFieldProps(name).onChange(e);
          handleInputChange(e);
        }}
        rows="4"
        cols="50"
      ></textarea>
      {(min > 0 || max > 0) && (
        <div className={styles.charCounterContainer}>
          <span className={`${styles.minText} ${isTooSmall ? styles.errorText : ""}`}>
            {min > 0 ? `Minimum ${min} characters required.` : ""}
          </span>
          <span className={`${styles.countText} ${isTooMuch ? styles.errorText : ""}`}>
            {max > 0 ? `${charCount} of ${max} max` : ""}
          </span>
        </div>
      )}
      <ErrorMessage name={name} />
    </div>
  );
}
